import { Route, Routes } from 'react-router-dom';
import './App.css';
import { AdminOnlyRoute, ProtectedRoute } from './components/ProtectedRoute';
import ForgotPassword from './pages/auth/ForgotPassword';
import Login from './pages/auth/Login';
import ResetCredential from './pages/auth/ResetCredential';
import Signup from './pages/auth/Signup';
import VerifyAccount from './pages/auth/VerifyAccount';
import Dashboard from './pages/dashboard/Dashboard';
import ApiSettings from './pages/settings/ApiSettings';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import ProjectDetail from './pages/project/Project';
import DatablockBuilder from './pages/datablock/DatablockBuilder';
import DatablockEditor from './pages/datablock/DatablockEditor';
import Landing from './pages/content/Landing';
import Users from './pages/settings/Users';
import Onboard from './pages/auth/Onboard';
import AccountSettings from './pages/settings/AccountSettings';
import Pricing from './pages/content/Pricing';
import BillingSettings from './pages/settings/BillingSettings';
import TermsAndConditions from './pages/content/TermsAndConditions';
import Privacy from './pages/content/Privacy';
import { useEffect } from 'react';
import { initGA } from './hooks/useGoogleAnalytics';
import ComingSoon from './pages/content/ComingSoon';
import APIDocs from './pages/content/APIDocs/APIDocs';

const App = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      initGA();
    }
  }, []);
  return (
    <>
      <MantineProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<ComingSoon />} />
          <Route path="/api-docs" element={<APIDocs />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
          <Route path="/verify" element={<VerifyAccount />} />
          <Route path="/onboard" element={<Onboard />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetCredential />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:project_key"
            element={
              <ProtectedRoute>
                <ProjectDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:project_key/datablock/build"
            element={
              <ProtectedRoute>
                <DatablockBuilder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:project_key/environment/:env_key/datablock/:datablock_key/edit"
            element={
              <ProtectedRoute>
                <DatablockEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api"
            element={
              <ProtectedRoute>
                <ApiSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/users"
            element={
              <AdminOnlyRoute>
                <Users />
              </AdminOnlyRoute>
            }
          />
          <Route
            path="/settings/account"
            element={
              <ProtectedRoute>
                <AccountSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/billing"
            element={
              <AdminOnlyRoute>
                <BillingSettings />
              </AdminOnlyRoute>
            }
          />
        </Routes>
      </MantineProvider>
    </>
  );
};

export default App;
